// Cross-tab session sync via BroadcastChannel: login/logout are intents, postLogin/postLogout are sync signals.
const CHANNEL_NAME = 'efiber-auth';

const channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel(CHANNEL_NAME) : null;

export function postAuthEvent(type, payload = {}) {
	if (!channel) return;
	channel.postMessage({ type, payload });
}

export function onAuthEvent(handler) {
	if (!channel) return;
	channel.onmessage = (event) => handler(event.data);
}
